import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const CpdCourseTsiStyle = withTheme(styled.div`
  .container {
    max-width: 1182px;
    margin: 4rem auto;
  }
  .section-text {
    font-size: 32px;
    font-weight: 700;
    margin-top: 48px;
    margin-left: 15px;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .container {
      padding: 0px 16px;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
    .section-text {
      font-size: 22px;
      margin-top: 40px;
    }
  }
`);

export default CpdCourseTsiStyle;
